/* eslint-disable import/no-named-as-default */
import React from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import AgencyProfile from "./AgencyProfile";

const ProviderComponent = ({
  recruiterUserId,
  engagementId,
  adminManagedEngagements,
}) => (
  <Provider store={store}>
    <AgencyProfile
      recruiterUserId={recruiterUserId}
      engagementId={engagementId}
      adminManagedEngagements={adminManagedEngagements}
    />
  </Provider>
);

ProviderComponent.propTypes = {
  recruiterUserId: PropTypes.number.isRequired,
  engagementId: PropTypes.number,
  adminManagedEngagements: PropTypes.bool,
};

ProviderComponent.defaultProps = {
  engagementId: PropTypes.isNull,
  adminManagedEngagements: false,
};

export default ProviderComponent;
